import CCSparkline from "../Common/CCSparkline";
import {prepareBuffer} from "../../util/Buffer";

class ExampleSparkline extends CCSparkline {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const data = [1, 4, 2, 5, 7, 2, 4, 6, 3, 8, 5, 9];

        this.setState({Loading: this.state.fetchBackgroundOperation, Data: data});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let data = []
        for (let i = 0; i < buffer.length; i++) {
            data.push(parseFloat(buffer[i].get("Y_AXIS_1")) || 0);
        }

        this.setState({Loading: false, Data: data});
    };
}

export default ExampleSparkline;
